module.exports = __webpack_public_path__ + "b4c1a929c453f9ea6035ca91cfdf55e2.MP3";